import { Drawer as TmovDrawer } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import ListaDocumentosProvider from '../../../../../../contexts/ListaDocumentos';
import { DrawerHeader } from '../components/DrawerHeader';
import TrackingTabs from './TrackingTabs';

export function DrawerTracking({
  dadosMotorista,
  trackingDetails,
  documentosMotorista,
  onClose,
  visivel,
}) {
  return (
    <TmovDrawer
      style={{
        width: '480px',
      }}
      header={
        <DrawerHeader
          headerTitle="Detalhes"
          headerDescription="Acompanhe a viagem, visualize os dados do motorista e baixe documentos."
        />
      }
      active={visivel}
      updateActive={onClose}
    >
      <div>
        <ListaDocumentosProvider>
          <TrackingTabs
            dadosMotorista={dadosMotorista}
            eventosMotorista={trackingDetails.eventosMotorista}
            documentosMotorista={documentosMotorista}
          />
        </ListaDocumentosProvider>
      </div>
    </TmovDrawer>
  );
}

const docsShape = PropTypes.shape({
  id: PropTypes.string,
  tipoDocumento: PropTypes.number,
  tipoDocumentoDescricao: PropTypes.string,
  dataCriacao: PropTypes.string,
  isMaxicon: PropTypes.bool,
  link: PropTypes.string,
  idUsuario: PropTypes.number,
  idUsuarioShipper: PropTypes.number,
});

const handleCloseShape = PropTypes.shape({
  setDadosMotorista: PropTypes.func,
  setDocumentosMotorista: PropTypes.func,
  setDrawerController: PropTypes.func,
});

const eventosShape = PropTypes.shape({
  status: PropTypes.string,
  nomeAutor: PropTypes.string,
  dataAlteracao: PropTypes.string,
});

DrawerTracking.propTypes = {
  dadosMotorista: PropTypes.shape({
    IdLoteConjunto: PropTypes.number,
    IdLote: PropTypes.number,
    Nome: PropTypes.string,
    PlacaCavalo: PropTypes.string,
    Peso: PropTypes.string,
    EntradaFila: PropTypes.string,
    StatusInt: PropTypes.number,
    DataEmissaoCte: PropTypes.string,
    IsTransportadoraExterna: PropTypes.bool,
    NomeTransportadora: PropTypes.string,
    Status: PropTypes.string,
    Protocolo: PropTypes.string,
    IdFilial: PropTypes.number,
    LatitudeCheckin: PropTypes.number,
    LongitudeCheckin: PropTypes.number,
    UltimoCheckin: PropTypes.string,
    Cpf: PropTypes.string,
  }),
  trackingDetails: PropTypes.shape({
    dataIntegracaoCTE: PropTypes.string,
    entradaFila: PropTypes.string,
    dataEntrouEmTransito: PropTypes.string,
    dataFinalizacao: PropTypes.string,
    dataAguardandoAprovacao: PropTypes.string,
    status: PropTypes.number,
    idLoteConjunto: PropTypes.number,
    nome: PropTypes.string,
    placa: PropTypes.string,
    peso: PropTypes.string,
    cte: PropTypes.string,
    cpf: PropTypes.string,
    telefone: PropTypes.string,
    idOrdem: PropTypes.number,
    idLote: PropTypes.number,
    ocValidada: PropTypes.bool,
    numOrdemCarregamento: PropTypes.string,
    destino: PropTypes.string,
    origem: PropTypes.string,
    valor: PropTypes.number,
    produto: PropTypes.string,
    pedagio: PropTypes.number,
    protocolo: PropTypes.string,
    valorPedagio: PropTypes.number,
    filial: PropTypes.string,
    statusGr: PropTypes.number,
    observacaoGr: PropTypes.string,
    contrato: PropTypes.string,
    exigeChecklist: PropTypes.bool,
    eventosMotorista: PropTypes.arrayOf(eventosShape),
  }).isRequired,
  documentosMotorista: PropTypes.arrayOf(docsShape),
  onClose: PropTypes.shape(handleCloseShape),
  visivel: PropTypes.bool,
};

DrawerTracking.defaultProps = {
  dadosMotorista: {},
  documentosMotorista: [],
  onClose: {
    handleCloseDrawer: () => {},
  },
  visivel: false,
};
